import get from "lodash/get";

export const isDownloadFileFetching = state => get(state, "download.isFetching", false);
